<template>
  <div id="maps">
    <div id="servermap" style="width:100%;height:600px"/>
  </div>
</template>
<script>
var AMap = process.env.ENV_SERVER === 'hpnw' ? '' : require('AMap')
// import AMap from "AMap";
AMap &&
  AMap.plugin(
    [
      "AMap.Scale",
      "AMap.DistrictSearch",
      "AMap.PlaceSearch",
      "AMap.Marker",
      "AMap.IndoorMap",
      "AMap.ToolBar",
      "AMap.OverView",
      "AMap.Geocoder",
      "AMap.MapType",
      "AMap.MouseTool",
      "AMap.Polyline"
    ],
    function() {}
  );
export default {
  props: {
    viewbasdata: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      map: null,
      marker: null,
      infoWindow: null,
      imgurl: ""
    };
  },
  watch: {
    viewbasdata(newdata) {
      if (newdata) {
        this.init();
      }
    }
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.map = new AMap.Map("servermap", {
        mapStyle: "amap://styles/whitesmoke",
        resizeEnable: true,
        zoom: 16
      });
      console.log(this.viewbasdata);
      var __this = this;

      var geocoder = new AMap.Geocoder({
        city: "上海",
      });
      geocoder.getLocation(__this.viewbasdata.address, function(
        icon,
        status,
        result
      ) {
       
        if (__this.viewbasdata.latitude && __this.viewbasdata.longitude) {
        //    var endicon = new AMap.Icon({
        //   // 图标尺寸
        //   // 图标所用图片大小
        //   size: new AMap.Size(40, 40),
        //   image:"",
        //   // 图标取图偏移量
        //    imageSize: new AMap.Size(40, 40),
        //   imageOffset: new AMap.Pixel(0,0),
        // });
        
          const lat = __this.viewbasdata.latitude;
          const lng = __this.viewbasdata.longitude;
          __this.map.setCenter([lng, lat]);
          __this.marker = new AMap.Marker({
            position: [lng, lat],
            map: __this.map,
            // icon:endicon
          });
        //  __this.map.add(__this.marker);
          const content = [
            '<div style="position:relative;top:32px;left:142px;width:280px; background:#fff; z-index:-10;padding:0 20px;font-family:test; border:1px solid #ea9639"border-radius: 2px;><img src="/static/xfz.png" style="width:40px;position: absolute;bottom: -20px;left: -20px;"><p style="font-size: 14px;line-height:30px; color:#0A2549; font-weight:700">' +
              (__this.viewbasdata.name || "暂无数据") +
              ' </p><p style="font-size: 14px;width：340px; margin-top:-18px; color:#0A2549;">' +
              (__this.viewbasdata.address || "暂无数据") +
              " </p></div>"
          ];
          __this.infoWindow = new AMap.InfoWindow({
            isCustom: true, // 使用自定义窗体
            content: content.join("<br/>"),
            offset: new AMap.Pixel(16, -45),
          });
          // __this.marker.setMap(__this.map)
          __this.infoWindow.open(__this.map, __this.marker.getPosition());
          // __this.map.add(__this.marker);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/basicComponents/awap.vue